import type { AccountData as Account } from '~publish/contexts/AccountContext'

export const hasDismissedObject = (args: {
  account: Account | null
  objectId: string
}): boolean => {
  const { account, objectId } = args

  if (!account) {
    return false
  }

  if (!account.currentOrganization) {
    return false
  }

  if (!account.currentOrganization.dismissedObjects) {
    return false
  }

  return (
    account.currentOrganization.dismissedObjects.some(
      (item) => item?.id === objectId,
    ) || false
  )
}
